import React from "react";
import { Result, Button } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const PRIMARY_COLOR = "#a32a29";

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <Result
        status="403"
        title="Access Denied"
        subTitle="You do not have permission to view this page."
        icon={<LockOutlined style={styles.icon} />}
        // extra={
        //   <Button
        //     type="primary"
        //     style={styles.button}
        //     onClick={() => navigate("/")}
        //   >
        //     Go to Home
        //   </Button>
        // }
      />
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "rgba(255, 255, 255, 0.3)",
  },
  icon: {
    fontSize: "50px",
    color: PRIMARY_COLOR,
    animation: "bounce 1.5s infinite",
  },
  button: {
    backgroundColor: PRIMARY_COLOR,
    borderColor: PRIMARY_COLOR,
    fontSize: "16px",
    padding: "8px 20px",
    borderRadius: "5px",
    transition: "all 0.3s ease-in-out",
  },
};

export default AccessDenied;
